import React from 'react';

class BillingCtrl extends React.Component {
    render() {
        return (
            <div className = 'dms-body' >
                {this.props.children}
            </div>
        )
    }
};
export default BillingCtrl;



// WEBPACK FOOTER //
// ./src/routes/billingCtrl/index.js